// source: WsResultPb.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = function () {
  return this || window || global || self || Function('return this')()
}.call(null)

var MainPairPb_pb = require('./MainPairPb_pb.js')
goog.object.extend(proto, MainPairPb_pb)
var RecommendPairPb_pb = require('./RecommendPairPb_pb.js')
goog.object.extend(proto, RecommendPairPb_pb)
var AmountPairPb_pb = require('./AmountPairPb_pb.js')
goog.object.extend(proto, AmountPairPb_pb)
var UpPairPb_pb = require('./UpPairPb_pb.js')
goog.object.extend(proto, UpPairPb_pb)
var StarPairPb_pb = require('./StarPairPb_pb.js')
goog.object.extend(proto, StarPairPb_pb)
var TradeAreaPairPb_pb = require('./TradeAreaPairPb_pb.js')
goog.object.extend(proto, TradeAreaPairPb_pb)
var KlineListPb_pb = require('./KlineListPb_pb.js')
goog.object.extend(proto, KlineListPb_pb)
var TradeDepthVoPb_pb = require('./TradeDepthVoPb_pb.js')
goog.object.extend(proto, TradeDepthVoPb_pb)
var TradeDetailListPb_pb = require('./TradeDetailListPb_pb.js')
goog.object.extend(proto, TradeDetailListPb_pb)
var TradeTickerVoPb_pb = require('./TradeTickerVoPb_pb.js')
goog.object.extend(proto, TradeTickerVoPb_pb)
var EntrustVoPb_pb = require('./EntrustVoPb_pb.js')
goog.object.extend(proto, EntrustVoPb_pb)
var UserAssetBalancePb_pb = require('./UserAssetBalancePb_pb.js')
goog.object.extend(proto, UserAssetBalancePb_pb)
var MarketTickerListPb_pb = require('./MarketTickerListPb_pb.js')
goog.object.extend(proto, MarketTickerListPb_pb)
var MarketMonitPb_pb = require('./MarketMonitPb_pb.js')
goog.object.extend(proto, MarketMonitPb_pb)
var MarginCrossAssetVoPb_pb = require('./MarginCrossAssetVoPb_pb.js')
goog.object.extend(proto, MarginCrossAssetVoPb_pb)
var MarginIsolatedAssetVoPb_pb = require('./MarginIsolatedAssetVoPb_pb.js')
goog.object.extend(proto, MarginIsolatedAssetVoPb_pb)
var NewListingPairPb_pb = require('./NewListingPairPb_pb.js')
goog.object.extend(proto, NewListingPairPb_pb)
var ChgDistributionsPb_pb = require('./ChgDistributionsPb_pb.js')
goog.object.extend(proto, ChgDistributionsPb_pb)
var MarketZonesPb_pb = require('./MarketZonesPb_pb.js')
goog.object.extend(proto, MarketZonesPb_pb)
var KlineOrdersPb_pb = require('./KlineOrdersPb_pb.js')
goog.object.extend(proto, KlineOrdersPb_pb)
var NotificationPushPb_pb = require('./NotificationPushPb_pb.js')
goog.object.extend(proto, NotificationPushPb_pb)
var TradeHotListingPairPb_pb = require('./TradeHotListingPairPb_pb.js')
goog.object.extend(proto, TradeHotListingPairPb_pb)
var CtcGoingOrderNumPb_pb = require('./CtcGoingOrderNumPb_pb.js')
goog.object.extend(proto, CtcGoingOrderNumPb_pb)
var MarketMultiChangePb_pb = require('./MarketMultiChangePb_pb.js')
goog.object.extend(proto, MarketMultiChangePb_pb)
var MarketHeatmapPb_pb = require('./MarketHeatmapPb_pb.js')
goog.object.extend(proto, MarketHeatmapPb_pb)
var CurrencyRateListPb_pb = require('./CurrencyRateListPb_pb.js')
goog.object.extend(proto, CurrencyRateListPb_pb)
var LiveRoomListPb_pb = require('./LiveRoomListPb_pb.js')
goog.object.extend(proto, LiveRoomListPb_pb)
goog.exportSymbol('proto.WsResultPb', null, global)
goog.exportSymbol('proto.WsResultPb.DataCase', null, global)
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.WsResultPb = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.WsResultPb.oneofGroups_)
}
goog.inherits(proto.WsResultPb, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.WsResultPb.displayName = 'proto.WsResultPb'
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.WsResultPb.oneofGroups_ = [
  [21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
]

/**
 * @enum {number}
 */
proto.WsResultPb.DataCase = {
  DATA_NOT_SET: 0,
  KLINELIST: 21,
  TRADEDEPTHVO: 22,
  TRADEDETAILLIST: 23,
  TRADEAREAPAIR: 24,
  MAINPAIR: 25,
  RECOMMENDPAIR: 26,
  UPPAIR: 27,
  AMTPAIR: 28,
  STARPAIR: 29,
  TRADETICKERVO: 30,
  ENTRUSTVO: 31,
  USERASSETBALANCE: 32,
  MARKETTICKERLIST: 33,
  MARKETMONIT: 34,
  MARGINCROSSASSETVO: 35,
  MARGINISOLATEDASSETVO: 36,
  NEWLISTINGPAIR: 37,
  CHGDISTRIBUTIONS: 38,
  MARKETZONES: 39,
  KLINEORDERS: 40,
  NOTIFICATIONPUSH: 41,
  TRADEHOTLISTING: 42,
  CTCGOINGORDERNUM: 43,
  MULTICHANGE: 44,
  HEATMAP: 45,
  DOWNPAIR: 46,
  HEATVOL: 47,
  CURRENCYRATE: 48,
  LIVEROOMLIST: 49,
}

/**
 * @return {proto.WsResultPb.DataCase}
 */
proto.WsResultPb.prototype.getDataCase = function () {
  return /** @type {proto.WsResultPb.DataCase} */ (
    jspb.Message.computeOneofCase(this, proto.WsResultPb.oneofGroups_[0])
  )
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.WsResultPb.prototype.toObject = function (opt_includeInstance) {
    return proto.WsResultPb.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.WsResultPb} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.WsResultPb.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        code: jspb.Message.getFieldWithDefault(msg, 1, 0),
        msg: jspb.Message.getFieldWithDefault(msg, 2, ''),
        status: jspb.Message.getFieldWithDefault(msg, 3, ''),
        ts: jspb.Message.getFieldWithDefault(msg, 4, 0),
        ch: jspb.Message.getFieldWithDefault(msg, 5, ''),
        klinelist: (f = msg.getKlinelist()) && KlineListPb_pb.KlineListPb.toObject(includeInstance, f),
        tradedepthvo: (f = msg.getTradedepthvo()) && TradeDepthVoPb_pb.TradeDepthVoPb.toObject(includeInstance, f),
        tradedetaillist:
          (f = msg.getTradedetaillist()) && TradeDetailListPb_pb.TradeDetailListPb.toObject(includeInstance, f),
        tradeareapair: (f = msg.getTradeareapair()) && TradeAreaPairPb_pb.TradeAreaPairPb.toObject(includeInstance, f),
        mainpair: (f = msg.getMainpair()) && MainPairPb_pb.MainPairPb.toObject(includeInstance, f),
        recommendpair: (f = msg.getRecommendpair()) && RecommendPairPb_pb.RecommendPairPb.toObject(includeInstance, f),
        uppair: (f = msg.getUppair()) && UpPairPb_pb.UpPairPb.toObject(includeInstance, f),
        amtpair: (f = msg.getAmtpair()) && AmountPairPb_pb.AmountPairPb.toObject(includeInstance, f),
        starpair: (f = msg.getStarpair()) && StarPairPb_pb.StarPairPb.toObject(includeInstance, f),
        tradetickervo: (f = msg.getTradetickervo()) && TradeTickerVoPb_pb.TradeTickerVoPb.toObject(includeInstance, f),
        entrustvo: (f = msg.getEntrustvo()) && EntrustVoPb_pb.EntrustVoPb.toObject(includeInstance, f),
        userassetbalance:
          (f = msg.getUserassetbalance()) && UserAssetBalancePb_pb.UserAssetBalancePb.toObject(includeInstance, f),
        markettickerlist:
          (f = msg.getMarkettickerlist()) && MarketTickerListPb_pb.MarketTickerListPb.toObject(includeInstance, f),
        marketmonit: (f = msg.getMarketmonit()) && MarketMonitPb_pb.MarketMonitPb.toObject(includeInstance, f),
        margincrossassetvo:
          (f = msg.getMargincrossassetvo()) &&
          MarginCrossAssetVoPb_pb.MarginCrossAssetVoPb.toObject(includeInstance, f),
        marginisolatedassetvo:
          (f = msg.getMarginisolatedassetvo()) &&
          MarginIsolatedAssetVoPb_pb.MarginIsolatedAssetVoPb.toObject(includeInstance, f),
        newlistingpair:
          (f = msg.getNewlistingpair()) && NewListingPairPb_pb.NewListingPairPb.toObject(includeInstance, f),
        chgdistributions:
          (f = msg.getChgdistributions()) && ChgDistributionsPb_pb.ChgDistributionsPb.toObject(includeInstance, f),
        marketzones: (f = msg.getMarketzones()) && MarketZonesPb_pb.MarketZonesPb.toObject(includeInstance, f),
        klineorders: (f = msg.getKlineorders()) && KlineOrdersPb_pb.KlineOrdersPb.toObject(includeInstance, f),
        notificationpush:
          (f = msg.getNotificationpush()) && NotificationPushPb_pb.NotificationPushPb.toObject(includeInstance, f),
        tradehotlisting:
          (f = msg.getTradehotlisting()) && TradeHotListingPairPb_pb.TradeHotListingPairPb.toObject(includeInstance, f),
        ctcgoingordernum:
          (f = msg.getCtcgoingordernum()) && CtcGoingOrderNumPb_pb.CtcGoingOrderNumPb.toObject(includeInstance, f),
        multichange:
          (f = msg.getMultichange()) && MarketMultiChangePb_pb.MarketMultiChangePb.toObject(includeInstance, f),
        heatmap: (f = msg.getHeatmap()) && MarketHeatmapPb_pb.MarketHeatmapPb.toObject(includeInstance, f),
        downpair: (f = msg.getDownpair()) && UpPairPb_pb.UpPairPb.toObject(includeInstance, f),
        heatvol: (f = msg.getHeatvol()) && MarketHeatmapPb_pb.MarketHeatmapPb.toObject(includeInstance, f),
        currencyrate:
          (f = msg.getCurrencyrate()) && CurrencyRateListPb_pb.CurrencyRateListPb.toObject(includeInstance, f),
        liveroomlist: (f = msg.getLiveroomlist()) && LiveRoomListPb_pb.LiveRoomListPb.toObject(includeInstance, f),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.WsResultPb}
 */
proto.WsResultPb.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.WsResultPb()
  return proto.WsResultPb.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.WsResultPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.WsResultPb}
 */
proto.WsResultPb.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setCode(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setMsg(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setStatus(value)
        break
      case 4:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setTs(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setCh(value)
        break
      case 21:
        var value = new KlineListPb_pb.KlineListPb()
        reader.readMessage(value, KlineListPb_pb.KlineListPb.deserializeBinaryFromReader)
        msg.setKlinelist(value)
        break
      case 22:
        var value = new TradeDepthVoPb_pb.TradeDepthVoPb()
        reader.readMessage(value, TradeDepthVoPb_pb.TradeDepthVoPb.deserializeBinaryFromReader)
        msg.setTradedepthvo(value)
        break
      case 23:
        var value = new TradeDetailListPb_pb.TradeDetailListPb()
        reader.readMessage(value, TradeDetailListPb_pb.TradeDetailListPb.deserializeBinaryFromReader)
        msg.setTradedetaillist(value)
        break
      case 24:
        var value = new TradeAreaPairPb_pb.TradeAreaPairPb()
        reader.readMessage(value, TradeAreaPairPb_pb.TradeAreaPairPb.deserializeBinaryFromReader)
        msg.setTradeareapair(value)
        break
      case 25:
        var value = new MainPairPb_pb.MainPairPb()
        reader.readMessage(value, MainPairPb_pb.MainPairPb.deserializeBinaryFromReader)
        msg.setMainpair(value)
        break
      case 26:
        var value = new RecommendPairPb_pb.RecommendPairPb()
        reader.readMessage(value, RecommendPairPb_pb.RecommendPairPb.deserializeBinaryFromReader)
        msg.setRecommendpair(value)
        break
      case 27:
        var value = new UpPairPb_pb.UpPairPb()
        reader.readMessage(value, UpPairPb_pb.UpPairPb.deserializeBinaryFromReader)
        msg.setUppair(value)
        break
      case 28:
        var value = new AmountPairPb_pb.AmountPairPb()
        reader.readMessage(value, AmountPairPb_pb.AmountPairPb.deserializeBinaryFromReader)
        msg.setAmtpair(value)
        break
      case 29:
        var value = new StarPairPb_pb.StarPairPb()
        reader.readMessage(value, StarPairPb_pb.StarPairPb.deserializeBinaryFromReader)
        msg.setStarpair(value)
        break
      case 30:
        var value = new TradeTickerVoPb_pb.TradeTickerVoPb()
        reader.readMessage(value, TradeTickerVoPb_pb.TradeTickerVoPb.deserializeBinaryFromReader)
        msg.setTradetickervo(value)
        break
      case 31:
        var value = new EntrustVoPb_pb.EntrustVoPb()
        reader.readMessage(value, EntrustVoPb_pb.EntrustVoPb.deserializeBinaryFromReader)
        msg.setEntrustvo(value)
        break
      case 32:
        var value = new UserAssetBalancePb_pb.UserAssetBalancePb()
        reader.readMessage(value, UserAssetBalancePb_pb.UserAssetBalancePb.deserializeBinaryFromReader)
        msg.setUserassetbalance(value)
        break
      case 33:
        var value = new MarketTickerListPb_pb.MarketTickerListPb()
        reader.readMessage(value, MarketTickerListPb_pb.MarketTickerListPb.deserializeBinaryFromReader)
        msg.setMarkettickerlist(value)
        break
      case 34:
        var value = new MarketMonitPb_pb.MarketMonitPb()
        reader.readMessage(value, MarketMonitPb_pb.MarketMonitPb.deserializeBinaryFromReader)
        msg.setMarketmonit(value)
        break
      case 35:
        var value = new MarginCrossAssetVoPb_pb.MarginCrossAssetVoPb()
        reader.readMessage(value, MarginCrossAssetVoPb_pb.MarginCrossAssetVoPb.deserializeBinaryFromReader)
        msg.setMargincrossassetvo(value)
        break
      case 36:
        var value = new MarginIsolatedAssetVoPb_pb.MarginIsolatedAssetVoPb()
        reader.readMessage(value, MarginIsolatedAssetVoPb_pb.MarginIsolatedAssetVoPb.deserializeBinaryFromReader)
        msg.setMarginisolatedassetvo(value)
        break
      case 37:
        var value = new NewListingPairPb_pb.NewListingPairPb()
        reader.readMessage(value, NewListingPairPb_pb.NewListingPairPb.deserializeBinaryFromReader)
        msg.setNewlistingpair(value)
        break
      case 38:
        var value = new ChgDistributionsPb_pb.ChgDistributionsPb()
        reader.readMessage(value, ChgDistributionsPb_pb.ChgDistributionsPb.deserializeBinaryFromReader)
        msg.setChgdistributions(value)
        break
      case 39:
        var value = new MarketZonesPb_pb.MarketZonesPb()
        reader.readMessage(value, MarketZonesPb_pb.MarketZonesPb.deserializeBinaryFromReader)
        msg.setMarketzones(value)
        break
      case 40:
        var value = new KlineOrdersPb_pb.KlineOrdersPb()
        reader.readMessage(value, KlineOrdersPb_pb.KlineOrdersPb.deserializeBinaryFromReader)
        msg.setKlineorders(value)
        break
      case 41:
        var value = new NotificationPushPb_pb.NotificationPushPb()
        reader.readMessage(value, NotificationPushPb_pb.NotificationPushPb.deserializeBinaryFromReader)
        msg.setNotificationpush(value)
        break
      case 42:
        var value = new TradeHotListingPairPb_pb.TradeHotListingPairPb()
        reader.readMessage(value, TradeHotListingPairPb_pb.TradeHotListingPairPb.deserializeBinaryFromReader)
        msg.setTradehotlisting(value)
        break
      case 43:
        var value = new CtcGoingOrderNumPb_pb.CtcGoingOrderNumPb()
        reader.readMessage(value, CtcGoingOrderNumPb_pb.CtcGoingOrderNumPb.deserializeBinaryFromReader)
        msg.setCtcgoingordernum(value)
        break
      case 44:
        var value = new MarketMultiChangePb_pb.MarketMultiChangePb()
        reader.readMessage(value, MarketMultiChangePb_pb.MarketMultiChangePb.deserializeBinaryFromReader)
        msg.setMultichange(value)
        break
      case 45:
        var value = new MarketHeatmapPb_pb.MarketHeatmapPb()
        reader.readMessage(value, MarketHeatmapPb_pb.MarketHeatmapPb.deserializeBinaryFromReader)
        msg.setHeatmap(value)
        break
      case 46:
        var value = new UpPairPb_pb.UpPairPb()
        reader.readMessage(value, UpPairPb_pb.UpPairPb.deserializeBinaryFromReader)
        msg.setDownpair(value)
        break
      case 47:
        var value = new MarketHeatmapPb_pb.MarketHeatmapPb()
        reader.readMessage(value, MarketHeatmapPb_pb.MarketHeatmapPb.deserializeBinaryFromReader)
        msg.setHeatvol(value)
        break
      case 48:
        var value = new CurrencyRateListPb_pb.CurrencyRateListPb()
        reader.readMessage(value, CurrencyRateListPb_pb.CurrencyRateListPb.deserializeBinaryFromReader)
        msg.setCurrencyrate(value)
        break
      case 49:
        var value = new LiveRoomListPb_pb.LiveRoomListPb()
        reader.readMessage(value, LiveRoomListPb_pb.LiveRoomListPb.deserializeBinaryFromReader)
        msg.setLiveroomlist(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.WsResultPb.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.WsResultPb.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.WsResultPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.WsResultPb.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getCode()
  if (f !== 0) {
    writer.writeInt32(1, f)
  }
  f = message.getMsg()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getStatus()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getTs()
  if (f !== 0) {
    writer.writeInt64(4, f)
  }
  f = message.getCh()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getKlinelist()
  if (f != null) {
    writer.writeMessage(21, f, KlineListPb_pb.KlineListPb.serializeBinaryToWriter)
  }
  f = message.getTradedepthvo()
  if (f != null) {
    writer.writeMessage(22, f, TradeDepthVoPb_pb.TradeDepthVoPb.serializeBinaryToWriter)
  }
  f = message.getTradedetaillist()
  if (f != null) {
    writer.writeMessage(23, f, TradeDetailListPb_pb.TradeDetailListPb.serializeBinaryToWriter)
  }
  f = message.getTradeareapair()
  if (f != null) {
    writer.writeMessage(24, f, TradeAreaPairPb_pb.TradeAreaPairPb.serializeBinaryToWriter)
  }
  f = message.getMainpair()
  if (f != null) {
    writer.writeMessage(25, f, MainPairPb_pb.MainPairPb.serializeBinaryToWriter)
  }
  f = message.getRecommendpair()
  if (f != null) {
    writer.writeMessage(26, f, RecommendPairPb_pb.RecommendPairPb.serializeBinaryToWriter)
  }
  f = message.getUppair()
  if (f != null) {
    writer.writeMessage(27, f, UpPairPb_pb.UpPairPb.serializeBinaryToWriter)
  }
  f = message.getAmtpair()
  if (f != null) {
    writer.writeMessage(28, f, AmountPairPb_pb.AmountPairPb.serializeBinaryToWriter)
  }
  f = message.getStarpair()
  if (f != null) {
    writer.writeMessage(29, f, StarPairPb_pb.StarPairPb.serializeBinaryToWriter)
  }
  f = message.getTradetickervo()
  if (f != null) {
    writer.writeMessage(30, f, TradeTickerVoPb_pb.TradeTickerVoPb.serializeBinaryToWriter)
  }
  f = message.getEntrustvo()
  if (f != null) {
    writer.writeMessage(31, f, EntrustVoPb_pb.EntrustVoPb.serializeBinaryToWriter)
  }
  f = message.getUserassetbalance()
  if (f != null) {
    writer.writeMessage(32, f, UserAssetBalancePb_pb.UserAssetBalancePb.serializeBinaryToWriter)
  }
  f = message.getMarkettickerlist()
  if (f != null) {
    writer.writeMessage(33, f, MarketTickerListPb_pb.MarketTickerListPb.serializeBinaryToWriter)
  }
  f = message.getMarketmonit()
  if (f != null) {
    writer.writeMessage(34, f, MarketMonitPb_pb.MarketMonitPb.serializeBinaryToWriter)
  }
  f = message.getMargincrossassetvo()
  if (f != null) {
    writer.writeMessage(35, f, MarginCrossAssetVoPb_pb.MarginCrossAssetVoPb.serializeBinaryToWriter)
  }
  f = message.getMarginisolatedassetvo()
  if (f != null) {
    writer.writeMessage(36, f, MarginIsolatedAssetVoPb_pb.MarginIsolatedAssetVoPb.serializeBinaryToWriter)
  }
  f = message.getNewlistingpair()
  if (f != null) {
    writer.writeMessage(37, f, NewListingPairPb_pb.NewListingPairPb.serializeBinaryToWriter)
  }
  f = message.getChgdistributions()
  if (f != null) {
    writer.writeMessage(38, f, ChgDistributionsPb_pb.ChgDistributionsPb.serializeBinaryToWriter)
  }
  f = message.getMarketzones()
  if (f != null) {
    writer.writeMessage(39, f, MarketZonesPb_pb.MarketZonesPb.serializeBinaryToWriter)
  }
  f = message.getKlineorders()
  if (f != null) {
    writer.writeMessage(40, f, KlineOrdersPb_pb.KlineOrdersPb.serializeBinaryToWriter)
  }
  f = message.getNotificationpush()
  if (f != null) {
    writer.writeMessage(41, f, NotificationPushPb_pb.NotificationPushPb.serializeBinaryToWriter)
  }
  f = message.getTradehotlisting()
  if (f != null) {
    writer.writeMessage(42, f, TradeHotListingPairPb_pb.TradeHotListingPairPb.serializeBinaryToWriter)
  }
  f = message.getCtcgoingordernum()
  if (f != null) {
    writer.writeMessage(43, f, CtcGoingOrderNumPb_pb.CtcGoingOrderNumPb.serializeBinaryToWriter)
  }
  f = message.getMultichange()
  if (f != null) {
    writer.writeMessage(44, f, MarketMultiChangePb_pb.MarketMultiChangePb.serializeBinaryToWriter)
  }
  f = message.getHeatmap()
  if (f != null) {
    writer.writeMessage(45, f, MarketHeatmapPb_pb.MarketHeatmapPb.serializeBinaryToWriter)
  }
  f = message.getDownpair()
  if (f != null) {
    writer.writeMessage(46, f, UpPairPb_pb.UpPairPb.serializeBinaryToWriter)
  }
  f = message.getHeatvol()
  if (f != null) {
    writer.writeMessage(47, f, MarketHeatmapPb_pb.MarketHeatmapPb.serializeBinaryToWriter)
  }
  f = message.getCurrencyrate()
  if (f != null) {
    writer.writeMessage(48, f, CurrencyRateListPb_pb.CurrencyRateListPb.serializeBinaryToWriter)
  }
  f = message.getLiveroomlist()
  if (f != null) {
    writer.writeMessage(49, f, LiveRoomListPb_pb.LiveRoomListPb.serializeBinaryToWriter)
  }
}

/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.WsResultPb.prototype.getCode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {number} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setCode = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value)
}

/**
 * optional string msg = 2;
 * @return {string}
 */
proto.WsResultPb.prototype.getMsg = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setMsg = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional string status = 3;
 * @return {string}
 */
proto.WsResultPb.prototype.getStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setStatus = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional int64 ts = 4;
 * @return {number}
 */
proto.WsResultPb.prototype.getTs = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0))
}

/**
 * @param {number} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setTs = function (value) {
  return jspb.Message.setProto3IntField(this, 4, value)
}

/**
 * optional string ch = 5;
 * @return {string}
 */
proto.WsResultPb.prototype.getCh = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setCh = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional KlineListPb klineList = 21;
 * @return {?proto.KlineListPb}
 */
proto.WsResultPb.prototype.getKlinelist = function () {
  return /** @type{?proto.KlineListPb} */ (jspb.Message.getWrapperField(this, KlineListPb_pb.KlineListPb, 21))
}

/**
 * @param {?proto.KlineListPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setKlinelist = function (value) {
  return jspb.Message.setOneofWrapperField(this, 21, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearKlinelist = function () {
  return this.setKlinelist(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasKlinelist = function () {
  return jspb.Message.getField(this, 21) != null
}

/**
 * optional TradeDepthVoPb tradeDepthVo = 22;
 * @return {?proto.TradeDepthVoPb}
 */
proto.WsResultPb.prototype.getTradedepthvo = function () {
  return /** @type{?proto.TradeDepthVoPb} */ (jspb.Message.getWrapperField(this, TradeDepthVoPb_pb.TradeDepthVoPb, 22))
}

/**
 * @param {?proto.TradeDepthVoPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setTradedepthvo = function (value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearTradedepthvo = function () {
  return this.setTradedepthvo(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasTradedepthvo = function () {
  return jspb.Message.getField(this, 22) != null
}

/**
 * optional TradeDetailListPb tradeDetailList = 23;
 * @return {?proto.TradeDetailListPb}
 */
proto.WsResultPb.prototype.getTradedetaillist = function () {
  return /** @type{?proto.TradeDetailListPb} */ (
    jspb.Message.getWrapperField(this, TradeDetailListPb_pb.TradeDetailListPb, 23)
  )
}

/**
 * @param {?proto.TradeDetailListPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setTradedetaillist = function (value) {
  return jspb.Message.setOneofWrapperField(this, 23, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearTradedetaillist = function () {
  return this.setTradedetaillist(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasTradedetaillist = function () {
  return jspb.Message.getField(this, 23) != null
}

/**
 * optional TradeAreaPairPb tradeAreaPair = 24;
 * @return {?proto.TradeAreaPairPb}
 */
proto.WsResultPb.prototype.getTradeareapair = function () {
  return /** @type{?proto.TradeAreaPairPb} */ (
    jspb.Message.getWrapperField(this, TradeAreaPairPb_pb.TradeAreaPairPb, 24)
  )
}

/**
 * @param {?proto.TradeAreaPairPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setTradeareapair = function (value) {
  return jspb.Message.setOneofWrapperField(this, 24, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearTradeareapair = function () {
  return this.setTradeareapair(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasTradeareapair = function () {
  return jspb.Message.getField(this, 24) != null
}

/**
 * optional MainPairPb mainPair = 25;
 * @return {?proto.MainPairPb}
 */
proto.WsResultPb.prototype.getMainpair = function () {
  return /** @type{?proto.MainPairPb} */ (jspb.Message.getWrapperField(this, MainPairPb_pb.MainPairPb, 25))
}

/**
 * @param {?proto.MainPairPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setMainpair = function (value) {
  return jspb.Message.setOneofWrapperField(this, 25, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearMainpair = function () {
  return this.setMainpair(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasMainpair = function () {
  return jspb.Message.getField(this, 25) != null
}

/**
 * optional RecommendPairPb recommendPair = 26;
 * @return {?proto.RecommendPairPb}
 */
proto.WsResultPb.prototype.getRecommendpair = function () {
  return /** @type{?proto.RecommendPairPb} */ (
    jspb.Message.getWrapperField(this, RecommendPairPb_pb.RecommendPairPb, 26)
  )
}

/**
 * @param {?proto.RecommendPairPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setRecommendpair = function (value) {
  return jspb.Message.setOneofWrapperField(this, 26, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearRecommendpair = function () {
  return this.setRecommendpair(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasRecommendpair = function () {
  return jspb.Message.getField(this, 26) != null
}

/**
 * optional UpPairPb upPair = 27;
 * @return {?proto.UpPairPb}
 */
proto.WsResultPb.prototype.getUppair = function () {
  return /** @type{?proto.UpPairPb} */ (jspb.Message.getWrapperField(this, UpPairPb_pb.UpPairPb, 27))
}

/**
 * @param {?proto.UpPairPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setUppair = function (value) {
  return jspb.Message.setOneofWrapperField(this, 27, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearUppair = function () {
  return this.setUppair(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasUppair = function () {
  return jspb.Message.getField(this, 27) != null
}

/**
 * optional AmountPairPb amtPair = 28;
 * @return {?proto.AmountPairPb}
 */
proto.WsResultPb.prototype.getAmtpair = function () {
  return /** @type{?proto.AmountPairPb} */ (jspb.Message.getWrapperField(this, AmountPairPb_pb.AmountPairPb, 28))
}

/**
 * @param {?proto.AmountPairPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setAmtpair = function (value) {
  return jspb.Message.setOneofWrapperField(this, 28, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearAmtpair = function () {
  return this.setAmtpair(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasAmtpair = function () {
  return jspb.Message.getField(this, 28) != null
}

/**
 * optional StarPairPb starPair = 29;
 * @return {?proto.StarPairPb}
 */
proto.WsResultPb.prototype.getStarpair = function () {
  return /** @type{?proto.StarPairPb} */ (jspb.Message.getWrapperField(this, StarPairPb_pb.StarPairPb, 29))
}

/**
 * @param {?proto.StarPairPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setStarpair = function (value) {
  return jspb.Message.setOneofWrapperField(this, 29, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearStarpair = function () {
  return this.setStarpair(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasStarpair = function () {
  return jspb.Message.getField(this, 29) != null
}

/**
 * optional TradeTickerVoPb tradeTickerVo = 30;
 * @return {?proto.TradeTickerVoPb}
 */
proto.WsResultPb.prototype.getTradetickervo = function () {
  return /** @type{?proto.TradeTickerVoPb} */ (
    jspb.Message.getWrapperField(this, TradeTickerVoPb_pb.TradeTickerVoPb, 30)
  )
}

/**
 * @param {?proto.TradeTickerVoPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setTradetickervo = function (value) {
  return jspb.Message.setOneofWrapperField(this, 30, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearTradetickervo = function () {
  return this.setTradetickervo(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasTradetickervo = function () {
  return jspb.Message.getField(this, 30) != null
}

/**
 * optional EntrustVoPb entrustVo = 31;
 * @return {?proto.EntrustVoPb}
 */
proto.WsResultPb.prototype.getEntrustvo = function () {
  return /** @type{?proto.EntrustVoPb} */ (jspb.Message.getWrapperField(this, EntrustVoPb_pb.EntrustVoPb, 31))
}

/**
 * @param {?proto.EntrustVoPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setEntrustvo = function (value) {
  return jspb.Message.setOneofWrapperField(this, 31, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearEntrustvo = function () {
  return this.setEntrustvo(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasEntrustvo = function () {
  return jspb.Message.getField(this, 31) != null
}

/**
 * optional UserAssetBalancePb userAssetBalance = 32;
 * @return {?proto.UserAssetBalancePb}
 */
proto.WsResultPb.prototype.getUserassetbalance = function () {
  return /** @type{?proto.UserAssetBalancePb} */ (
    jspb.Message.getWrapperField(this, UserAssetBalancePb_pb.UserAssetBalancePb, 32)
  )
}

/**
 * @param {?proto.UserAssetBalancePb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setUserassetbalance = function (value) {
  return jspb.Message.setOneofWrapperField(this, 32, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearUserassetbalance = function () {
  return this.setUserassetbalance(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasUserassetbalance = function () {
  return jspb.Message.getField(this, 32) != null
}

/**
 * optional MarketTickerListPb marketTickerList = 33;
 * @return {?proto.MarketTickerListPb}
 */
proto.WsResultPb.prototype.getMarkettickerlist = function () {
  return /** @type{?proto.MarketTickerListPb} */ (
    jspb.Message.getWrapperField(this, MarketTickerListPb_pb.MarketTickerListPb, 33)
  )
}

/**
 * @param {?proto.MarketTickerListPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setMarkettickerlist = function (value) {
  return jspb.Message.setOneofWrapperField(this, 33, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearMarkettickerlist = function () {
  return this.setMarkettickerlist(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasMarkettickerlist = function () {
  return jspb.Message.getField(this, 33) != null
}

/**
 * optional MarketMonitPb marketMonit = 34;
 * @return {?proto.MarketMonitPb}
 */
proto.WsResultPb.prototype.getMarketmonit = function () {
  return /** @type{?proto.MarketMonitPb} */ (jspb.Message.getWrapperField(this, MarketMonitPb_pb.MarketMonitPb, 34))
}

/**
 * @param {?proto.MarketMonitPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setMarketmonit = function (value) {
  return jspb.Message.setOneofWrapperField(this, 34, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearMarketmonit = function () {
  return this.setMarketmonit(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasMarketmonit = function () {
  return jspb.Message.getField(this, 34) != null
}

/**
 * optional MarginCrossAssetVoPb marginCrossAssetVo = 35;
 * @return {?proto.MarginCrossAssetVoPb}
 */
proto.WsResultPb.prototype.getMargincrossassetvo = function () {
  return /** @type{?proto.MarginCrossAssetVoPb} */ (
    jspb.Message.getWrapperField(this, MarginCrossAssetVoPb_pb.MarginCrossAssetVoPb, 35)
  )
}

/**
 * @param {?proto.MarginCrossAssetVoPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setMargincrossassetvo = function (value) {
  return jspb.Message.setOneofWrapperField(this, 35, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearMargincrossassetvo = function () {
  return this.setMargincrossassetvo(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasMargincrossassetvo = function () {
  return jspb.Message.getField(this, 35) != null
}

/**
 * optional MarginIsolatedAssetVoPb marginIsolatedAssetVo = 36;
 * @return {?proto.MarginIsolatedAssetVoPb}
 */
proto.WsResultPb.prototype.getMarginisolatedassetvo = function () {
  return /** @type{?proto.MarginIsolatedAssetVoPb} */ (
    jspb.Message.getWrapperField(this, MarginIsolatedAssetVoPb_pb.MarginIsolatedAssetVoPb, 36)
  )
}

/**
 * @param {?proto.MarginIsolatedAssetVoPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setMarginisolatedassetvo = function (value) {
  return jspb.Message.setOneofWrapperField(this, 36, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearMarginisolatedassetvo = function () {
  return this.setMarginisolatedassetvo(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasMarginisolatedassetvo = function () {
  return jspb.Message.getField(this, 36) != null
}

/**
 * optional NewListingPairPb newListingPair = 37;
 * @return {?proto.NewListingPairPb}
 */
proto.WsResultPb.prototype.getNewlistingpair = function () {
  return /** @type{?proto.NewListingPairPb} */ (
    jspb.Message.getWrapperField(this, NewListingPairPb_pb.NewListingPairPb, 37)
  )
}

/**
 * @param {?proto.NewListingPairPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setNewlistingpair = function (value) {
  return jspb.Message.setOneofWrapperField(this, 37, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearNewlistingpair = function () {
  return this.setNewlistingpair(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasNewlistingpair = function () {
  return jspb.Message.getField(this, 37) != null
}

/**
 * optional ChgDistributionsPb chgDistributions = 38;
 * @return {?proto.ChgDistributionsPb}
 */
proto.WsResultPb.prototype.getChgdistributions = function () {
  return /** @type{?proto.ChgDistributionsPb} */ (
    jspb.Message.getWrapperField(this, ChgDistributionsPb_pb.ChgDistributionsPb, 38)
  )
}

/**
 * @param {?proto.ChgDistributionsPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setChgdistributions = function (value) {
  return jspb.Message.setOneofWrapperField(this, 38, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearChgdistributions = function () {
  return this.setChgdistributions(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasChgdistributions = function () {
  return jspb.Message.getField(this, 38) != null
}

/**
 * optional MarketZonesPb marketZones = 39;
 * @return {?proto.MarketZonesPb}
 */
proto.WsResultPb.prototype.getMarketzones = function () {
  return /** @type{?proto.MarketZonesPb} */ (jspb.Message.getWrapperField(this, MarketZonesPb_pb.MarketZonesPb, 39))
}

/**
 * @param {?proto.MarketZonesPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setMarketzones = function (value) {
  return jspb.Message.setOneofWrapperField(this, 39, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearMarketzones = function () {
  return this.setMarketzones(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasMarketzones = function () {
  return jspb.Message.getField(this, 39) != null
}

/**
 * optional KlineOrdersPb klineOrders = 40;
 * @return {?proto.KlineOrdersPb}
 */
proto.WsResultPb.prototype.getKlineorders = function () {
  return /** @type{?proto.KlineOrdersPb} */ (jspb.Message.getWrapperField(this, KlineOrdersPb_pb.KlineOrdersPb, 40))
}

/**
 * @param {?proto.KlineOrdersPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setKlineorders = function (value) {
  return jspb.Message.setOneofWrapperField(this, 40, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearKlineorders = function () {
  return this.setKlineorders(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasKlineorders = function () {
  return jspb.Message.getField(this, 40) != null
}

/**
 * optional NotificationPushPb notificationPush = 41;
 * @return {?proto.NotificationPushPb}
 */
proto.WsResultPb.prototype.getNotificationpush = function () {
  return /** @type{?proto.NotificationPushPb} */ (
    jspb.Message.getWrapperField(this, NotificationPushPb_pb.NotificationPushPb, 41)
  )
}

/**
 * @param {?proto.NotificationPushPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setNotificationpush = function (value) {
  return jspb.Message.setOneofWrapperField(this, 41, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearNotificationpush = function () {
  return this.setNotificationpush(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasNotificationpush = function () {
  return jspb.Message.getField(this, 41) != null
}

/**
 * optional TradeHotListingPairPb tradeHotListing = 42;
 * @return {?proto.TradeHotListingPairPb}
 */
proto.WsResultPb.prototype.getTradehotlisting = function () {
  return /** @type{?proto.TradeHotListingPairPb} */ (
    jspb.Message.getWrapperField(this, TradeHotListingPairPb_pb.TradeHotListingPairPb, 42)
  )
}

/**
 * @param {?proto.TradeHotListingPairPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setTradehotlisting = function (value) {
  return jspb.Message.setOneofWrapperField(this, 42, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearTradehotlisting = function () {
  return this.setTradehotlisting(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasTradehotlisting = function () {
  return jspb.Message.getField(this, 42) != null
}

/**
 * optional CtcGoingOrderNumPb ctcGoingOrderNum = 43;
 * @return {?proto.CtcGoingOrderNumPb}
 */
proto.WsResultPb.prototype.getCtcgoingordernum = function () {
  return /** @type{?proto.CtcGoingOrderNumPb} */ (
    jspb.Message.getWrapperField(this, CtcGoingOrderNumPb_pb.CtcGoingOrderNumPb, 43)
  )
}

/**
 * @param {?proto.CtcGoingOrderNumPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setCtcgoingordernum = function (value) {
  return jspb.Message.setOneofWrapperField(this, 43, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearCtcgoingordernum = function () {
  return this.setCtcgoingordernum(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasCtcgoingordernum = function () {
  return jspb.Message.getField(this, 43) != null
}

/**
 * optional MarketMultiChangePb multiChange = 44;
 * @return {?proto.MarketMultiChangePb}
 */
proto.WsResultPb.prototype.getMultichange = function () {
  return /** @type{?proto.MarketMultiChangePb} */ (
    jspb.Message.getWrapperField(this, MarketMultiChangePb_pb.MarketMultiChangePb, 44)
  )
}

/**
 * @param {?proto.MarketMultiChangePb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setMultichange = function (value) {
  return jspb.Message.setOneofWrapperField(this, 44, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearMultichange = function () {
  return this.setMultichange(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasMultichange = function () {
  return jspb.Message.getField(this, 44) != null
}

/**
 * optional MarketHeatmapPb heatmap = 45;
 * @return {?proto.MarketHeatmapPb}
 */
proto.WsResultPb.prototype.getHeatmap = function () {
  return /** @type{?proto.MarketHeatmapPb} */ (
    jspb.Message.getWrapperField(this, MarketHeatmapPb_pb.MarketHeatmapPb, 45)
  )
}

/**
 * @param {?proto.MarketHeatmapPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setHeatmap = function (value) {
  return jspb.Message.setOneofWrapperField(this, 45, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearHeatmap = function () {
  return this.setHeatmap(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasHeatmap = function () {
  return jspb.Message.getField(this, 45) != null
}

/**
 * optional UpPairPb downPair = 46;
 * @return {?proto.UpPairPb}
 */
proto.WsResultPb.prototype.getDownpair = function () {
  return /** @type{?proto.UpPairPb} */ (jspb.Message.getWrapperField(this, UpPairPb_pb.UpPairPb, 46))
}

/**
 * @param {?proto.UpPairPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setDownpair = function (value) {
  return jspb.Message.setOneofWrapperField(this, 46, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearDownpair = function () {
  return this.setDownpair(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasDownpair = function () {
  return jspb.Message.getField(this, 46) != null
}

/**
 * optional MarketHeatmapPb heatvol = 47;
 * @return {?proto.MarketHeatmapPb}
 */
proto.WsResultPb.prototype.getHeatvol = function () {
  return /** @type{?proto.MarketHeatmapPb} */ (
    jspb.Message.getWrapperField(this, MarketHeatmapPb_pb.MarketHeatmapPb, 47)
  )
}

/**
 * @param {?proto.MarketHeatmapPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setHeatvol = function (value) {
  return jspb.Message.setOneofWrapperField(this, 47, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearHeatvol = function () {
  return this.setHeatvol(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasHeatvol = function () {
  return jspb.Message.getField(this, 47) != null
}

/**
 * optional CurrencyRateListPb currencyRate = 48;
 * @return {?proto.CurrencyRateListPb}
 */
proto.WsResultPb.prototype.getCurrencyrate = function () {
  return /** @type{?proto.CurrencyRateListPb} */ (
    jspb.Message.getWrapperField(this, CurrencyRateListPb_pb.CurrencyRateListPb, 48)
  )
}

/**
 * @param {?proto.CurrencyRateListPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setCurrencyrate = function (value) {
  return jspb.Message.setOneofWrapperField(this, 48, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearCurrencyrate = function () {
  return this.setCurrencyrate(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasCurrencyrate = function () {
  return jspb.Message.getField(this, 48) != null
}

/**
 * optional LiveRoomListPb liveRoomList = 49;
 * @return {?proto.LiveRoomListPb}
 */
proto.WsResultPb.prototype.getLiveroomlist = function () {
  return /** @type{?proto.LiveRoomListPb} */ (jspb.Message.getWrapperField(this, LiveRoomListPb_pb.LiveRoomListPb, 49))
}

/**
 * @param {?proto.LiveRoomListPb|undefined} value
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.setLiveroomlist = function (value) {
  return jspb.Message.setOneofWrapperField(this, 49, proto.WsResultPb.oneofGroups_[0], value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.WsResultPb} returns this
 */
proto.WsResultPb.prototype.clearLiveroomlist = function () {
  return this.setLiveroomlist(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WsResultPb.prototype.hasLiveroomlist = function () {
  return jspb.Message.getField(this, 49) != null
}

goog.object.extend(exports, proto)
